<template>
	<div id="app" class="wrapper">
		<loader class="global-loader" :loading="$store.state.loading > 0"></loader>
		<main-header></main-header>
		<div class="main__content">
			<transition name="fade" mode="out-in">
				<router-view></router-view>
			</transition>
			<div class="disclaimer">
				<div class="container">
					<p>* Boats shown have been shipped to the dealer and may or may not be delivered to the dealer already. Please confirm with your dealer for the boats availability.</p>
				</div>
			</div>
		</div>
		<main-footer></main-footer>
		<div class="alert-stack">
            <alert v-model="$store.state.errors" type="danger"></alert>
            <alert v-model="$store.state.messages" type="info"></alert>
            <alert v-model="$store.state.warnings" type="warning"></alert>
        </div>
	</div>
</template>

<script>
	export default {
		data() {
			return {};
		},
		methods: {
			fadeSplash() {
				const splash = document.getElementById('splash');
			    splash.style.opacity = splash.style.opacity - 0.05;
			    if(splash.style.opacity <= 0){
			        splash.parentNode.removeChild(splash);
			        return;
			    }
			    window.requestAnimationFrame(this.fadeSplash);
			},
			async load() {
				try {
					const init = await this.$get('/json/init');
					this.$store.state.location = init.location;
				} catch(e) {
					console.log(e);
				}
			}
		},
		async serverPrefetch() {
			await this.load();
		},
		async mounted() {
			const webp = document.createElement('canvas');
			if (!!(webp.getContext && webp.getContext('2d'))) {
			    if(webp.toDataURL('image/webp').indexOf('data:image/webp') == 0) {
			        this.$store.state.webp = '.webp';
			    }
			}
			await this.$nextTick();
			document.getElementById('splash').style.opacity = 1;
    		window.requestAnimationFrame(this.fadeSplash);
		}
	}
</script>